import { createFeature, createReducer, on } from '@ngrx/store';
import {
  loadUser,
  loadUserSuccess,
  loadUserFailure,
  loadRoles,
  loadRolesSuccess,
  loadRolesFailure,
  loadOwnUnfreezeRequestSuccess,
  requestOwnUnfreeze,
  requestOwnUnfreezeSuccess,
  requestOwnUnfreezeFailure,
} from './dashboard.actions';
import { LocalizedCode, UserProfileResponse } from '../models/dashboard.model';

export interface UserState {
  user: UserProfileResponse | null;
  loading: boolean;
  error: any;
  roles: LocalizedCode[] | null;
  rolesLoading: boolean;
  rolesError: any;
  /** The signed-in user's own pending unfreeze request, when they are frozen. */
  ownUnfreezeRequestId: string | null;
  ownUnfreezeRequesting: boolean;
}

export const initialState: UserState = {
  user: null,
  loading: false,
  error: null,
  roles: null,
  rolesLoading: false,
  rolesError: null,
  ownUnfreezeRequestId: null,
  ownUnfreezeRequesting: false,
};

// Create the feature with auto-generated selectors
export const dashboardFeature = createFeature({
  name: 'dashboard',
  reducer: createReducer(
    initialState,
    on(loadUser, state => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(loadUserSuccess, (state, { user }) => ({
      ...state,
      user,
      loading: false,
      error: null,
    })),
    on(loadUserFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error: error.message,
    })),
    on(loadRoles, state => ({
      ...state,
      rolesLoading: true,
      rolesError: null,
    })),
    on(loadRolesSuccess, (state, { roles }) => ({
      ...state,
      roles,
      rolesLoading: false,
      rolesError: null,
    })),
    on(loadRolesFailure, (state, { error }) => ({
      ...state,
      rolesLoading: false,
      rolesError: error?.message ?? error,
    })),
    on(loadOwnUnfreezeRequestSuccess, (state, { pendingRequestId }) => ({
      ...state,
      ownUnfreezeRequestId: pendingRequestId,
    })),
    on(requestOwnUnfreeze, state => ({
      ...state,
      ownUnfreezeRequesting: true,
    })),
    on(requestOwnUnfreezeSuccess, (state, { requestId }) => ({
      ...state,
      ownUnfreezeRequestId: requestId,
      ownUnfreezeRequesting: false,
    })),
    on(requestOwnUnfreezeFailure, state => ({
      ...state,
      ownUnfreezeRequesting: false,
    }))
  ),
});
